var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-content"},[_c('div',{class:{ 'active': _vm.activeTab == 'artworks' }},[_c('ArtworksTab')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa264e84","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/search_page/index/components/tabs_content.vue
// module id = 811
// module chunks = 0 1 2 3 4 5 6 7 8 10 32 40